export const STATUS_HEX = {
  scheduled: "#3b82f6",
  in_progress: "#f59e0b",
  customer_home: "#6366f1",
  walk_away: "#f43f5e",
  completed: "#10b981",
  cancelled: "#a1a1aa",
};

const PALETTE = ["#2563eb", "#dc2626", "#16a34a", "#9333ea", "#ea580c", "#0891b2", "#db2777", "#65a30d", "#7c3aed", "#ca8a04", "#0f766e", "#be123c"];

export const locksmithColor = (id) => {
  let h = 0;
  for (const c of id || "") h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
};
